import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming cookie helper is in this location

const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/company';

export default function getCompanies() {
    // Retrieve the token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return (
        axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            }
        })
        .then(res => {
            // console.log('companies: ', res.data.data[0]); 
            return res.data;
        })
        .catch(err => {
            // console.error('Error fetching companies:', err);
            return err;
        })
    );
}
